const privilegeMixin = {
  computed: {
    isProd () {
      return process.env.NODE_ENV === 'production'
    }
  },
  methods: {
    getPrivilege (role) {
      return this.$store.getters.getPrivilege(role)
    },
    isAuth (role, type) {
      return Array.isArray(role) ? this.arrHandler(role, type) : this.getPrivilege(role)
    },
    arrHandler (role, type) {
      return type === 'some' ? role.map((r) => this.getPrivilege(r)).some((e) => e) : role.map((r) => this.getPrivilege(r)).every((e) => e)
    },
    showLabel (role, type = 'some') {
      return this.isProd ? this.isAuth(role, type) : true
    },
    getLabel (role, label, type = 'some') {
      return this.isAuth(role, type) ? label : 'UNAUTHORIZED'
    },
    getIconColor ({ role, errColor = '', successColor = 'primary', type = 'some' }) {
      return this.isAuth(role, type) ? successColor : errColor
    }
  }
}

export default privilegeMixin